<div
    [ngClass]="{'scss-block-background-color-variable': type === WebsiteBlockEmbedType.AccentBackgroundDefault,
                'scss-website-background-color-only': type === WebsiteBlockEmbedType.Default}">
    @switch (Scope.websiteMode) {
        @case (WebsiteMode.Live) {
            <div class="d-flex position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.ReadOnly) {
            <div class="d-flex position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </lib-design-blocks-action-menu>
        }
    }
</div>

<ng-template #blockContent>
    <div class="d-flex fullWidth justify-content-center ">
        @if (designBlockMode === DesignBlockMode.Sidebar) {
            <img src="assets/images/Website_MapBlock_Sidebar.png" class="scss-embed-block-sidebar "/>
        }
        @if (designBlockMode !== DesignBlockMode.Sidebar) {
            @if ((Scope.websiteMode === WebsiteMode.Preview || (Scope.websiteMode === WebsiteMode.ReadOnly)) && !url) {
                <div class="scss-spacing-embed-block w-100">
                    <div class="sb-empty-state-background-card">
                        <lib-empty-state
                            [emptyStateGraphic]="EmptyStateGraphic.Locations">
                            <ng-container emptyStateText i18n="@@Common_MapBlock_EmptyState_Title">No location set yet</ng-container>
                            <ng-container emptyStateDescription i18n="@@Common_MapBlock_EmptyState_Description">Choose the location you want to show here</ng-container>
                            <ng-container emptyStateButton>
                                <lib-button
                                    (clicked)="Scope.HandleBlockAction(websiteBlockData, WebsiteBlockAction.Edit)">
                                    <ng-container label i18n="@@Common_MapBlock_EmptyState_Button">Set Location</ng-container>
                                </lib-button>
                            </ng-container>
                        </lib-empty-state>
                    </div>
                </div>
            }
            @if (url) {
                    <iframe
                        [ngClass]="{'scss-spacing-embed-block': !isFullWidth}"
                        height="464"
                        style="border:0"
                        loading="lazy"
                        allowfullscreen
                        referrerpolicy="no-referrer-when-downgrade"
                        [style.width]="'100%'"
                        [src]="url! | trustUrl">
                    </iframe>
            }
        }
    </div>
</ng-template>